import { ClickEventType } from "../ClickEvent";
import { HoverEventType } from "../HoverEvent";
import { v4 as uuidv4 } from "uuid";
export class Snippet {
    constructor(id = null) {
        this.bold = false;
        this.italic = false;
        this.underlined = false;
        this.strikethrough = false;
        this.obfuscated = false;
        this.font = null;
        this.color = "none";
        this.insertion = "";
        this.click_event_type = ClickEventType.none;
        this.click_event_value = "";
        this.hover_event_type = HoverEventType.none;
        this.hover_event_value = "";
        this.hover_event_object = {};
        this.hover_event_children = [];
        if (id !== null) {
            this.id = id;
        }
        else {
            this.id = uuidv4();
        }
    }
    editor_fields() {
        return [];
    }
    value(field) {
        return this[field.field];
    }
}
